// extracted by mini-css-extract-plugin
export default {"infoItem":"InfoItem_infoItem__1145r","empty":"InfoItem_empty__uI9vn","link":"InfoItem_link__IIkds"};